import React from 'react';
import { FaSync } from 'react-icons/fa';

function StatBox({ 
  title, 
  value, 
  icon, 
  theme, 
  isNegative, 
  isPositive, 
  extra, 
  type, // 'inflow', 'outflow', 'balance'
  useDefaultBg = true, // Toggle background customization
  onRefresh,
  isRefreshing = false,
  syncedCount = 0
}) {
  const bgColors = {
    inflow: "bg-green-100",
    outflow: "bg-red-100",
    balance: "bg-blue-100",
  };

  return (
    <div
      className={`flex-1 flex items-center gap-4 rounded-lg p-5 shadow-md ${
        useDefaultBg ? "" : bgColors[type] || ""
      }`}
      style={{
        color: theme.colors.text.primary,
        backgroundColor: useDefaultBg ? theme.colors.background.secondary : undefined,
      }}
    >
      {icon && (
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-xl">
          {icon}
        </div>
      )}
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold">{title}</h3>
          <div className="flex items-center gap-2">
            {syncedCount > 0 && (
              <span className="px-2 py-1 bg-green-500 text-white text-xs rounded-full">
                +{syncedCount} new
              </span>
            )}
            {onRefresh && (
              <button
                onClick={onRefresh}
                disabled={isRefreshing}
                className="p-1 rounded hover:bg-gray-200 transition-colors disabled:opacity-50"
                title="Refresh data"
              >
                <FaSync className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`} />
              </button>
            )}
          </div>
        </div>
        <p
          className={`text-xl font-semibold ${
            isNegative ? "text-red-500" : isPositive ? "text-green-500" : ""
          }`}
        >
          {value}
        </p>
        {extra && <p className="text-sm text-gray-400">{extra}</p>}
      </div>
    </div>
  );
}

export default StatBox;
